var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"t1"},[_c('b-loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false}}),_c('div',{staticClass:"chart"},[_c('Bar',{staticStyle:{"{width":"100%","height":"250px}"},attrs:{"data":_vm.chartdata,"options":_vm.chartOptions,"css-classes":"chart","responsive":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }